/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["az-Cyrl",[["а","п"],["АМ","ПМ"]],[["АМ","ПМ"]],[["7","1","2","3","4","5","6"],["Б.","Б.Е.","Ч.А.","Ч.","Ҹ.А.","Ҹ.","Ш."],["базар","базар ертәси","чәршәнбә ахшамы","чәршәнбә","ҹүмә ахшамы","ҹүмә","шәнбә"],["Б.","Б.Е.","Ч.А.","Ч.","Ҹ.А.","Ҹ.","Ш."]],u,[["1","2","3","4","5","6","7","8","9","10","11","12"],["јан","фев","мар","апр","май","ијн","ијл","авг","сен","окт","ној","дек"],["јанвар","феврал","март","апрел","май","ијун","ијул","август","сентјабр","октјабр","нојабр","декабр"]],[["1","2","3","4","5","6","7","8","9","10","11","12"],["јан","фев","мар","апр","май","ијн","ијл","авг","сен","окт","ној","дек"],["Јанвар","Феврал","Март","Апрел","Май","Ијун","Ијул","Август","Сентјабр","Октјабр","Нојабр","Декабр"]],[["е.ә.","ј.е."],u,["ерамыздан әввәл","јени ера"]],1,[6,0],["dd.MM.yy","d MMM y","d MMMM y","d MMMM y, EEEE"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1} {0}",u,u,u],[",",".",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","#,##0.00 ¤","#E0"],"AZN","₼","AZN",{"AZN":["₼"],"JPY":["JP¥","¥"],"USD":["US$","$"]},"ltr", plural];
